module.exports = __webpack_public_path__ + "static/PoL_seo_01-e2ff60ef46a016c2c8cf6d600eaa328b.jpg";